// src/components/typography/SectionSubSubtitle.jsx
import React from "react";
import { Typography } from "@mui/material";

const sectionSubSubtitleSx = {
  fontSize: { xs: "1.05rem", md: "1.1rem" },
  fontWeight: 600,
  lineHeight: 1.45,
  mt: -1.5,
  mb: 0.8,
  color: "text.secondary",
};

export default function SectionSubSubtitle({ children, sx = {}, ...props }) {
  return (
    <Typography
      variant="subtitle1"
      sx={{ ...sectionSubSubtitleSx, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const sectionSubSubtitleStyle = sectionSubSubtitleSx;
